var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 6.75V11.25H6.75V6.75H11.25ZM13.5 4.5H4.5V13.5H13.5V4.5ZM11.25 18.75V23.25H6.75V18.75H11.25ZM13.5 16.5H4.5V25.5H13.5V16.5ZM23.25 6.75V11.25H18.75V6.75H23.25ZM25.5 4.5H16.5V13.5H25.5V4.5ZM16.5 16.5H18.75V18.75H16.5V16.5ZM18.75 18.75H21V21H18.75V18.75ZM21 16.5H23.25V18.75H21V16.5ZM16.5 21H18.75V23.25H16.5V21ZM18.75 23.25H21V25.5H18.75V23.25ZM21 21H23.25V23.25H21V21ZM23.25 18.75H25.5V21H23.25V18.75ZM23.25 23.25H25.5V25.5H23.25V23.25ZM30 7.5H27V3H22.5V0H30V7.5ZM30 30V22.5H27V27H22.5V30H30ZM0 30H7.5V27H3V22.5H0V30ZM0 0V7.5H3V3H7.5V0H0Z",
    fill: "#26284D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qr-code.d4dad1269e07acfe289e73a53e7166e5.svg";
export { ForwardRef as ReactComponent };